export default __webpack_public_path__ + "static/media/fruit24.b99b4073.jpg";